import { render, staticRenderFns } from "./ChapterQuickLinks.vue?vue&type=template&id=73a8ede8&"
import script from "./ChapterQuickLinks.vue?vue&type=script&lang=js&"
export * from "./ChapterQuickLinks.vue?vue&type=script&lang=js&"
import style0 from "./ChapterQuickLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports